var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:_vm.customClass},[(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title)+":")]):_vm._e(),_vm._v(_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }